import React from "react";
import { useLocation } from "react-router-dom";
import { StyledHeader, Logo, StyledLink, Menu } from "./styles";
import logo from "../../assets/SunWest-Logo.png";
import menu from "../../assets/menu-icon.svg";
import { StyledButtonHeader, TextBtnHeader } from "../Button/styles";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu";

export const Header = ({
  navigate,
  toggleForm,
  handleScroll,
  handleMenuToggle,
  menuToggle,
}) => {
  const location = useLocation().pathname;
  
  return (
    <StyledHeader>
      <Logo
        src={logo}
        alt='Sun West Mortgage'
        onClick={
          location === "/mytruehome"
            ? () => (window.location = "https://www.swmc.com")
            : () => navigate("/mytruehome")
        }
      />
      
      
      <StyledLink
        id="storiesLink"
        href="https://www.instagram.com/sunwestmortgage.inc/"
        target="_blank"
        color="blue"
      >
        
        Your Stories
      </StyledLink>
      <StyledLink id="tacaLink" onClick={() => handleScroll("taca")}>
        About TACA
      </StyledLink>
      <StyledLink id="swmcLink" onClick={() => handleScroll("swmc")}>
        About Sun West
      </StyledLink>
      <StyledLink className="d-xs-none"
        onClick={() => navigate("/mytruehome/contest-rules")}
        id="contestLink"
        as="div"
        color="blue"
      >
        Contest Rules
      </StyledLink>
      <StyledLink onClick={toggleForm}>
        Contact Us
      </StyledLink> 


      <Menu
        toggle={menuToggle}
        onClick={() => handleMenuToggle(menuToggle)}
        src={menu}
      />
      <StyledButtonHeader href=" https://www.swmc.com/mytruehome/contest-rules" target="_blank" >
        <TextBtnHeader>Contest Rules</TextBtnHeader>
      </StyledButtonHeader>
      <div className="desktop-AccessibilityMenu-show">
            <UserWayAccessibilityMenu color="black" width={40} height={40}/>
          </div>
    </StyledHeader>
  );
};
